import "./styles.css";
import React from "react";
import { Table } from "react-bootstrap";

function App() {
  //const students = ["student 1", "student 2", "student 3", 4, 4242];
  const students = [
    {
      name: "Vishish",
      email: "vj@test.com",
      address: [
        { hn: "10", city: "Bilaspur", state: "Chhattisgarh" },
        { hn: "32", city: "Raipur", state: "CG" },
        { hn: "33", city: "Mumbai", state: "Maharash" },
        { hn: "1", city: "Bnagalore", state: "Karnataka" }
      ]
    },
    {
      name: "Anish",
      email: "anish@test.com",
      address: [
        { hn: "5", city: "Bilaspur", state: "Chhattisgarh" },
        { hn: "6", city: "Raipur", state: "CG" },
        { hn: "7", city: "Mumbai", state: "Maharash" },
        { hn: "8", city: "Bnagalore", state: "Karnataka" }
      ]
    },
    {
      name: "Kailash",
      email: "kk@test.com",
      address: [
        { hn: "33", city: "Bilaspur", state: "Chhattisgarh" },
        { hn: "55", city: "Raipur", state: "CG" },
        { hn: "66", city: "Mumbai", state: "Maharash" },
        { hn: "88", city: "Bnagalore", state: "Karnataka" }
      ]
    }
  ];
  return (
    <div className="App">
      <h1>Details</h1>
      <Table bordered>
        <tbody>
          <tr>
            <th>Name</th>
            <th>City</th>
            <th>Address</th>
          </tr>
          {students.map((item) => (
            <tr>
              <td>{item.name}</td>
              <td>{item.email}</td>
              <td>
                {item.address.map((item2) => (
                  <Table>
                    <tr>
                      <td>{item2.hn}</td>
                      <td>{item2.city}</td>
                      <td>{item2.state}</td>
                    </tr>
                  </Table>
                ))}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}

export default App;
